import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">编辑精选</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选爆料</h2>
          <p className="mt-2 text-foreground-600 text-sm">编辑团队每日精选最具价值的爆料资讯</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-700 rounded-md">
                    {item.tag}
                  </span>
                </div>
                {item.hot && (
                  <div className="absolute top-3 right-3">
                    <span className="px-2 py-0.5 text-[11px] font-medium bg-primary-500 text-background-50 rounded-full flex items-center gap-1">
                      <i className="ri-fire-line text-[10px]"></i>热
                    </span>
                  </div>
                )}
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {item.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}